import { Box, Typography } from '@mui/material';
import moment from 'moment';

import { formatTime, formatTimeRange } from '../../utils/datetimes/formatting';
import { formatDate } from '../../utils/datetimes/formatting';

export const DateTimeRangeDisplay = ({
    startDatetime,
    endDatetime,
    timezone,
}: {
    startDatetime: Date;
    endDatetime: Date;
    timezone: string;
}) => {
    const startMoment = moment(startDatetime);
    const endMoment = moment(endDatetime);
    if (startMoment.isSame(endMoment, 'day')) {
        return (
            <>
                <Typography fontWeight='bold'>{startMoment.format('dddd MMM D YYYY')}</Typography>
                <Typography>{formatTimeRange(startMoment, endMoment, timezone)}</Typography>
            </>
        );
    } else {
        return (
            <Box display='flex' alignItems='center'>
                <Box mr={3}>
                    <Typography variant='caption'>From</Typography>
                    <Typography fontWeight='bold'>
                        {formatDate({ datetime: startMoment, timezone })}
                    </Typography>
                    <Typography>{formatTime(startMoment, timezone)}</Typography>
                </Box>
                <Box>
                    <Typography variant='caption'>To</Typography>
                    <Typography fontWeight='bold'>
                        {formatDate({ datetime: endMoment, timezone })}
                    </Typography>
                    <Typography>{formatTime(endMoment, timezone)}</Typography>
                </Box>
            </Box>
        );
    }
};
